var exports = {
  "k": "xa15a2ab7--b67fba--container",
  "Z": "xa15a2ab7--b67fba--hero",
};

module.exports = exports;
